import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { S3_URL } from "../../constants";
import { useMutation } from "@apollo/client";
import { READ_SYSTEM_NOTICE } from "../../graphql/systemNotice/mutation";
const SystemNoticeDetail = () => {
  const location = useLocation();
  const systemNoticeData = location.state;

  const [readSystemNotice, { loading: readSystemNoticeLoading }] =
    useMutation(READ_SYSTEM_NOTICE);

  useEffect(() => {
    const _onReadSystemNotice = () => {
      try {
        if (readSystemNoticeLoading) return;
        readSystemNotice({
          variables: {
            where: {
              id: systemNoticeData?.id,
            },
          },
        });
      } catch (error) {
        console.log({ error });
      }
    };

    _onReadSystemNotice();
  }, [systemNoticeData]);

  const isLargeScreen = () => {
    if (typeof window !== "undefined") {
      const largeScreenWidth = 768;
      return window.innerWidth >= largeScreenWidth;
    }
    return false;
  };

  return (
    <div className="p-4">
      <div style={{ fontWeight: "bold", fontSize: 24 }}>
        ລາຍະອຽດການແຈ້ງເຕືອນ
      </div>
      <div style={{ fontWeight: "bold", fontSize: 20 }}>
        title: {systemNoticeData?.title}
      </div>
      {/* <div>detail: {systemNoticeData?.detail}</div> */}
      <div>
        link:{" "}
        {
          <a target="_blank" href={systemNoticeData?.link}>
            {" "}
            {systemNoticeData?.link}{" "}
          </a>
        }
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
        }}>
        {systemNoticeData?.details?.length > 0 &&
          systemNoticeData?.details?.map((detail, index) => (
            <div key={detail?.title + index} className="mt-2">
              <div>
                <p dangerouslySetInnerHTML={{ __html: detail?.title }} />
              </div>
              {detail?.images?.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginBottom: 10,
                  }}>
                  {detail?.images?.map((image) => {
                    return (
                      <img
                        key={{ image }}
                        src={S3_URL + image}
                        alt=""
                        style={{
                          width: isLargeScreen() ? "50%" : "100%",
                          height: "100%",
                          marginBottom: 15,
                        }}
                        placeholder="blur"
                        blurDataURL="/images/image_not_found.jpg"
                        loading="lazy"
                        onError={(e) => {
                          e.target.src = "/images/image_not_found.jpg";
                        }}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default SystemNoticeDetail;
